import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { usePagination } from 'Components/uiControls/Table/hooks';
import { Container } from '@mui/material';
import { TableView as Table, SearchInput, MenuComponent, IconButton, Tooltip } from '@gpstrackit/gtc-react-controls';

import { NotificationManager } from 'Components/Notifications';

import ModalCloneRoute from './components/modalCloneRoute'

import {
    Grid,
    Grow,
    Typography
  } from '@mui/material';

import {
    openModalRealtimeMapsUploadRoute
  } from 'Redux/actions';

import {
  openModalCreateEditRouteModalMain, 
  reset as resetRouteManagerCreateEditModalMain
} from './components/createEditRouteModalMain/redux/slice'

import { reset as resetEditPanelRoute } from './components/editPanelRoute/redux/slice'
import { reset as clearCreateEditRoutePoint } from './components/createEditRoutePoint/redux/slice'



import {
  routesEditPanelRouteGetRoute
} from "./components/editPanelRoute/redux/slice" // "../../views/templates/components/editPanelRoute/redux/slice";


import {
  openModalDeleteRoutePoints,
  reset as resetDeleteRoutePoint
} from './components/deleteRoutePoint/redux/slice'

//import { HasPermission } from "Core/security"
import './style.scss';

import { routesSearchRoutes } from './redux/slice'

import { openModalDeleteRoutes, reset as resetDeleteRoute } from './components/deleteRoute/redux/slice';

// Views
import UploadRoute from '../../../realtimeMaps/main/components/routes/components/uploadRoute';

const RoutesTemplates = (props) => {

    //intl
    const { messages, locale } = useIntl();
    const dispatch = useDispatch();

    const user = useSelector((state) => state.securityRedux.user);

    const [data, setData] = useState([]);

    

    const dataRoutesItems = useSelector(state => state.routesManagedRedux.routes);
    const loadingRoutes = useSelector(state => state.routesManagedRedux.loadingRoutes);
    const filters = useSelector(state => state.routesManagedRedux.filters);
    const openModalCreateEditRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.open);

    const isDeleteRoutes = useSelector(state => state.routesManagerDeleteRedux.isDeleteRoutes);
    const openModalDeleteRoute = useSelector(state => state.routesManagerDeleteRedux?.openModal);

    const openModalCloneRoutes = useSelector(state => state.routesTemplateModalCloneRoute.open);
    const deleteAllRoutePointsResponse = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.deleteAllRoutePointsResponse);
    const openModalDeleteRoutePointsVar = useSelector(state => state.routesManagerDeleteRoutePoint?.open);
    const openUploadRouteModal = useSelector(state => state.realtimeMapsRoutesModalUploadRoute.open); 
    const erorrRoutes = useSelector(state => state.routesManagedRedux.erorrRoutes);
    const routeManageCreateEditRouteModalMain = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.route);
    const routeToEditPanel = useSelector(state => state.routesManagerEditPanelRouteRedux?.route);
    const loadingSavedRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.loadingSavedRoute);
    const route = routeManageCreateEditRouteModalMain || routeToEditPanel

    const [rowsPerPage, setRowsPerPage] = useState(10);

    const routesTableRef = useRef();
    const pagination = usePagination(routesTableRef, routesSearchRoutes, filters);

    useEffect(() => {
        //get data for FSMRoutes
        dispatch(routesSearchRoutes({...filters}))
    }, [])

    useEffect(() => {
        if (dataRoutesItems) {
          setData(dataRoutesItems);
          pagination.setTotal(dataRoutesItems?.total || 0);
        }
      }, [dataRoutesItems]);

    useEffect(()=>{
      if(isDeleteRoutes){
        pagination?.resetTable()
        setRowsPerPage(10)
        //routesTableRef?.current?.setRowsPerPage(10)
      }
    },[isDeleteRoutes])

    useEffect(() => {
      if (loadingSavedRoute) {
        dispatch(routesSearchRoutes({ ...pagination.filters }))
      }
    }, [loadingSavedRoute]);

    const onChangePage = useCallback((newPage, newRowsPerPage, newSearchText) => {
      const newOffset = (newPage - 1) * newRowsPerPage;
      dispatch(routesSearchRoutes({
          ...filters,
          openSearch: newSearchText || "",
          limit: newRowsPerPage,
          offset: newOffset
      }));
    });

    useEffect(() => {
      if (openModalDeleteRoutePointsVar && (deleteAllRoutePointsResponse)) {
        if (erorrRoutes) {
          NotificationManager.error(
            messages['routes_error'],
            messages['error'],
            3000,
            null,
            null,
            'warning',
          );
        } else {
          NotificationManager.success(
            messages['fsmRoute_modal_delete_success'],
            messages['success'],
            3000,
            null,
            null,
            'success',
          );
          
        }
        dispatch(resetRouteManagerCreateEditModalMain({deleteAllRoutePointsResponse : false, errorOnMap: null}))
        if(route?.id > 0){
          dispatch(routesEditPanelRouteGetRoute({id: route?.id}))
        }
        dispatch(openModalDeleteRoutePoints({ open: false, routeId: 0 }))
        dispatch(resetDeleteRoutePoint())
      }
      
    }, [deleteAllRoutePointsResponse, openModalDeleteRoutePointsVar]);

    useEffect(() => {
        pagination.setColumns([
          {
            key: 'title',
            title: messages['fsmRoute_nameRoute'], //name
            show: true,
            export: true,
            render: (row) => {
              return (
                <Grid
                  container
                  alignItems="center"
                  justifyContent="flex-start"
                  className="context-menu-hover-container"
                  wrap="nowrap"
                >
                  
                  <div
                    style={{
                      display: 'flex', // Uso de flexbox
                      alignItems: 'center', // Alineación vertical al centro
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: `#${row?.color?.replace('#', '') }`,
                        width: '20px',
                        height: '20px',
                        borderRadius: '4px',
                        marginRight: '10px'
                      }}
                    ></div>
                  </div>
                  <div style={{ width: 200 }}>
                    {
                      row?.title?.length > 22
                      ?
                      <Tooltip title={row?.title} placement={'bottom'} /* type={ props?.tooltipType || null} */ >
                        <Typography className='template-routes-cut-text' noWrap>{row?.title}</Typography>
                      </Tooltip>
                      :
                      <Typography className='template-routes-cut-text' noWrap>{row?.title}</Typography>
                    }
                  </div>
    
                  {
                    /* HasPermission(user, "", [26]) && */
                    <Grid item justifyContent="flex-end">
                      <MenuComponent
                        disabled={loadingRoutes}
                        options={[
                          messages['edit'],
                          messages['delete'],
                          messages['fsmRoute_label_add_clone_route']
                        ]}
                        icon={'more_vert'}
                        placement={"right-start"}
                        className="context-menu-hover"
                        onClick={(type, value) => {
                          if (type === messages['edit']) {
                            dispatch(openModalCreateEditRouteModalMain({open: true, id: value.id, isTemplate: true}));

                          } else if (type === messages['delete']) {

                            const payload = {
                              content: messages['routes_deleteRouteContent'],
                              id: value.id,
                              open: true,
                              rows: [{ id: value.id, name: value.title }],
                              title: messages['routes_delete_routes_title'],
                              type: "route"
                            }
                            //dispatch(resetDeleteRoute())
                            dispatch(openModalDeleteRoutes(payload));
                          }  else if (type === messages['fsmRoute_label_add_clone_route']) {
                            dispatch(openModalCreateEditRouteModalMain({open: true, id: value.id, isTemplate: true, isCloneRoute: true, isRoutesTracker: true}));

                          }
                        }}
                        value={row}
                      />
                    </Grid>
                  }
                </Grid>
              )
            },
            exportValue: (row) => {
              return row?.name;
            },
            functionString: 'return row?.name || ""'
          },
          {
            key: 'start',
            title: messages['fsmRoute_start'],
            show: true,
            export: true,
            render: (row) => {
              return (
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  className="context-menu-container"
                  wrap="nowrap"
                >
                  <Grid item xs={11} onClick={() => {
                    //dispatch(openSettingsVehicleEquipmentAssignment(true,row));
                  }}>
                    <Typography noWrap>{row.startPoint || ''}</Typography>
                  </Grid>
                </Grid>
              )
            },
            exportValue: (row) => {
              return row?.vehicles?.length || ''
            },
            functionString: 'return row?.vehicles?.length ? row?.vehicles?.length :  ""'
          },
          {
            key: 'end',
            title: messages['fsmRoute_end'],
            show: true,
            export: true,
            render: (row) => {
              return (
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  className="context-menu-container"
                  wrap="nowrap"
                >
                  <Grid item xs={11} onClick={() => {
                    //dispatch(openSettingsVehicleEquipmentAssignment(true,row));
                  }}>
                    <Typography noWrap>{row?.endPoint || ''}</Typography>
                  </Grid>
                </Grid>
              )
            },
            exportValue: (row) => {
              return row?.vehicles?.length || ''
            },
            functionString: 'return row?.vehicles?.length ? row?.vehicles?.length :  ""'
          },
          {
            key: 'stop',
            title: messages['fsmRoute_stops'],
            show: true,
            export: true,
            render: (row) => {
              return (
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  className="context-menu-container"
                  wrap="nowrap"
                >
                  <Grid item xs={11} onClick={() => {
                    //dispatch(openSettingsVehicleEquipmentAssignment(true,row));
                  }}>
                    <Typography noWrap>{row?.pointsCount || 0}</Typography>
                  </Grid>
                </Grid>
              )
            },
            exportValue: (row) => {
              return row?.vehicles?.length || ''
            },
            functionString: 'return row?.vehicles?.length ? row?.vehicles?.length :  ""'
          }
    
        ]);
      }, [locale]);

    return(
      <Container maxWidth={false}>        
        <div id="containeGridNewRoutes">
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
                  <Grid item xs={6} sm={2}>
                      <Grid
                          container
                          direction="row"
                          justifyContent="flex-start"
                          alignItems="center"
                          spacing={1}
                      >

                          {
                            /* HasPermission(user, "ve", [25]) && */
                            <Grid item>
                              <div style={{ marginLeft: 6 }}>

                                <IconButton
                                  variant={"secondary"}
                                  isDisabled={false}
                                  icon="add_box"
                                  style={{ fontSize: 22, color: '#212121'}}
                                  tooltip={messages['add']}
                                  onClick={(e) => {
                                    dispatch(clearCreateEditRoutePoint())
                                    dispatch(resetRouteManagerCreateEditModalMain())
                                    dispatch(resetEditPanelRoute())
                                    dispatch(openModalCreateEditRouteModalMain({open: true, isTemplate: true}));
                                  }}
                                />
                              </div>
                            </Grid>
                          }

                          {
                              (pagination?.selectedItems.length > 0) && 
                              <Grid item>
                                  <IconButton
                                      icon="delete"
                                      placement="bottom"
                                      variant="secondary"
                                      size="small"
                                      tooltip={messages['delete']}
                                      isDisabled={loadingRoutes}
                                      onClick={() => {
                                        let payload = {
                                          open: true,
                                          type: "route",
                                          content: messages['routes_deleteRouteContent']
                                        };
                                        if(pagination?.selectedItems.length == 1){
                                          payload = {
                                            ...payload,
                                            id: pagination?.selectedItems[0].id,
                                            title: messages['routes_delete_routes_title'],
                                            rows: [{ id: pagination?.selectedItems[0].id, name: pagination?.selectedItems[0]?.title }]
                                          }
                                        }else if(pagination?.selectedItems.length > 1){
                                          payload = {
                                            ...payload,
                                            rows: pagination?.selectedItems.map((item) => ({ ...item, name: item.title })),
                                            type: 'route_multiple',
                                            title: messages['routes_delete_routes_title']
                                          }
                                        }
                                        dispatch(openModalDeleteRoutes(payload));
                                      }}
                                  />
                              </Grid>
                          }
                          <Grid item>
                                  <IconButton
                                      icon="upload_file"
                                      placement="bottom"
                                      variant="secondary"
                                      size="small"
                                      tooltip={messages['fsmRoute_upload_route']}
                                      isDisabled={loadingRoutes}
                                      onClick={() => {
                                        
                                        dispatch(openModalRealtimeMapsUploadRoute({ open: true }));
                                        
                                      }}
                                  />
                              </Grid>
                      </Grid>
                  </Grid>

                  <Grid item xs={12} sm={4} className="mb-10 text-right">
                    <SearchInput
                      placeholder={messages['search']}
                      {...pagination}
                    />
                  </Grid>
              </Grid>


                  
          <Table
              ref={routesTableRef}
              keyColumn="id"
              loading={loadingRoutes}
              topheight={235}
              data={data?.items || []}
              exportOrientation='landscape'
              exportName='routes-table'
              
              {...pagination}

              total={data?.total || 0}
              onChangePage={(newPage) => {
                onChangePage(newPage, rowsPerPage, pagination.searchText);
              }}
              onChangeRowsPerPage={(newRowsPerPage) => {
                setRowsPerPage(newRowsPerPage);
                onChangePage(1, newRowsPerPage, pagination.searchText);
              }}
              rowsPerPage={rowsPerPage}

              //hideDragable
              //disableItemSelection={!HasPermission(user, "", [26])}
          />
        </div>
      
      { openModalCloneRoutes && <ModalCloneRoute /> }
      { openUploadRouteModal && <UploadRoute isRealtimeMaps={false} /> }

      </Container>
      
    )

}

export default RoutesTemplates;